module.exports = __webpack_public_path__ + "static/media/S20-0967_F_C_Hompage_767x845_EN.43ef8530.jpg";